var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 492 492",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M484.09,227.108l-94.356-94.36c-5.064-5.06-11.82-7.844-19.028-7.844s-13.96,2.784-19.024,7.844l-16.12,16.128 c-5.064,5.064-7.852,11.82-7.852,19.024c0,7.208,2.788,14.084,7.852,19.152l20.388,20.508H165.382 c-14.836,0-26.944,11.824-26.944,26.656v22.8c0,14.832,12.108,27.416,26.944,27.416h191.74l-21.52,21.26 c-5.068,5.068-7.856,11.692-7.856,18.9c0,7.204,2.788,13.896,7.856,18.96l16.12,16.084c5.064,5.068,11.82,7.84,19.024,7.84 c7.208,0.008,13.964-2.796,19.028-7.86l94.316-94.324c5.08-5.08,7.868-11.864,7.848-19.08 C491.958,238.972,489.17,232.188,484.09,227.108z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M265.59,76.876c1.844,11.532,13.084,23.064,26.644,23.064h22.796c14.724,0,27.12-12.308,27.12-27.036v-34.4 C342.15,17.308,324.95,0,303.758,0H38.662c-21.2,0-38.6,17.308-38.6,38.504v414.904C0.062,474.6,17.466,492,38.662,492h265.096 c21.192,0,38.392-17.404,38.392-38.592v-34.592c0-14.728-12.4-26.752-27.12-26.752h-22.796c-13.616,0-24.916,11.532-26.672,23.064 H76.938V76.876H265.59z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtract);
export default __webpack_public_path__ + "static/media/extract.64e32d376ea117db4354c4230d316997.svg";
export { ForwardRef as ReactComponent };